import { NgModule } from '@angular/core';
import { Routes, RouterModule, ExtraOptions } from '@angular/router';

import { PATH } from './constants';

const routes: Routes = [
  { path: PATH.AUTH, loadChildren: () => import('./modules/authentication/authentication.module').then(m => m.AuthenticationModule) },
  { path: PATH.SHELL, loadChildren: () => import('./modules/shell/shell.module').then(m => m.ShellModule) },
  // Evita error por como estaba antes el ruteo del app
  { path: 's', loadChildren: () => import('./modules/shell/shell.module').then(m => m.ShellModule) },
  { path: '**', redirectTo: PATH.AUTH, pathMatch: 'full' }
];

const options: ExtraOptions = {
   scrollPositionRestoration: 'enabled',

  // enableTracing: true,
  // initialNavigation: 'enabled',
  // relativeLinkResolution: 'legacy',
};

@NgModule({
  imports: [RouterModule.forRoot(routes, options)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
